import createWixData, { Environment } from '@wix/wix-data-platformized-client'
import type { WixDataApi } from '@wix/wix-data-core'
import type { HttpClient } from '@wix/http-client'

const createWixDataClient = async ({
  httpClient,
  getGridAppId,
}: {
  httpClient: HttpClient
  getGridAppId: () => Promise<string | undefined>
}): Promise<WixDataApi> => {
  return createWixData({
    gridAppId: {
      get: getGridAppId,
    },
    environment: Environment.SANDBOX_PREFERRED,
    httpClient,
  })
}

export { createWixDataClient as createWixData }

export type WixDataCreator = typeof createWixDataClient
export type WixDataClient = WixDataApi
